import { useFetchUser } from '@jooxter/core';
import { JxtNavbar } from '@jooxter/ui';
import { Outlet } from 'react-router';
import useJooxterNavigation from '../../routes/hooks';

export const MenuLayout = () => {
  const { user } = useFetchUser();
  const [navigation] = useJooxterNavigation({ user });

  return (
    <>
      {/* Stays on top when the page scrolls. z-20: above the page and the desktop off-canvas (z-10), so its
          dropdowns open over an open off-canvas; under the modals and the mobile off-canvas (z-30). */}
      {user && (
        <div className="sticky top-0 z-20">
          <JxtNavbar
            user={user}
            routes={navigation.routes}
            buttons={navigation.buttons ?? []}
            logoRoute={navigation.baseRoute}
          />
        </div>
      )}
      <main className="bg-background grow">
        <Outlet />
      </main>
    </>
  );
};
